const BankSlip = () => {
  return "(Liberação até 3 dias úteis)";
};

export default BankSlip;
